var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{ref:"ContainerEditor"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('CoreEditor',{attrs:{"title":_vm.titleHead,"widthCanvas":_vm.wCanvas,"heightCanvas":_vm.hCanvas}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }